export default {
  namespaced: true,
  schedule_alarm: {
    title: "schedule alarm | schedules alarms",
    name: "name",
    apply_holliday: "apply holliday",
    allow_alarms: "allow alarms",
    replicate_all_days: "Replicate to all days",
    select_all_units: "Select all facilities",
    clear_all_units: "Remove all facilities",
    loading_all_units: "Loading facilities...",
    day: "day",
    month: "month",
    months: {
      january: 'january',
      february: 'february',
      march: 'march',
      april: 'april',
      may: 'may',
      june: 'june',
      july: 'july',
      august: 'august',
      september: 'september',
      october: 'october',
      november: 'november',
      december: 'december',
    },
  },
}
